import { render, staticRenderFns } from "./LiveDataList.vue?vue&type=template&id=81e378e2&scoped=true"
import script from "./LiveDataList.vue?vue&type=script&lang=js"
export * from "./LiveDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e378e2",
  null
  
)

export default component.exports